import e, { memo as C } from "react";
import { useTheme as b, AccordionItem as B, AccordionButton as P, Flex as m, Image as _, Text as h, AccordionIcon as v, AccordionPanel as z } from "@chakra-ui/react";
const M = C(
  ({
    heading: a,
    children: f,
    initialIcon: r,
    updatedIcon: t,
    mobileInitialIcon: o,
    mobileFilledIcon: c
  }) => {
    const {
      accordionBodyText: s,
      text: { default: g },
      accordionExtraSmallPadding: x,
      accordionIcon: i,
      accordionSmallIcon: y,
      accordionLargePadding: E,
      icon: { default: n },
      accordionInnerSpacing: d,
      borderStyle: { default: S },
      surface: { default: k },
      interactive: { background: p },
      accordionTitleText: A
    } = b(), { color: T } = S;
    return /* @__PURE__ */ e.createElement(
      B,
      {
        key: a,
        "data-testid": "menu-accordion-item",
        backgroundColor: k,
        borderTop: "none",
        borderColor: T
      },
      ({ isExpanded: l }) => {
        const u = l ? (c == null ? void 0 : c.url) ?? (t == null ? void 0 : t.url) : (o == null ? void 0 : o.url) ?? (r == null ? void 0 : r.url);
        return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
          P,
          {
            "data-testid": "menu-accordion-button",
            _hover: { background: p },
            px: E,
            py: d
          },
          /* @__PURE__ */ e.createElement(m, { flex: "1", textAlign: "left" }, u && /* @__PURE__ */ e.createElement(
            _,
            {
              "data-testid": "menu-accordion-left-icon",
              src: u,
              boxSize: i,
              color: n,
              display: "block",
              "aria-hidden": "true",
              alt: ""
            }
          ), /* @__PURE__ */ e.createElement(
            h,
            {
              "data-testid": "menu-accordion-title",
              sx: {
                margin: 0,
                py: x,
                pl: r && t ? d : "",
                color: g
              },
              ...l ? A : s
            },
            a
          )),
          /* @__PURE__ */ e.createElement(m, null, /* @__PURE__ */ e.createElement(
            v,
            {
              "data-testid": "menu-accordion-icon",
              color: n,
              fontSize: y,
              display: "block"
            }
          ))
        ), /* @__PURE__ */ e.createElement(z, { padding: 0 }, f));
      }
    );
  }
);
M.displayName = "AccordionItemMenu";
export {
  M as AccordionItemMenu
};
